// Korkenkick – helle Fassung „Editorial“: Interaktion & Scroll
// Jede Funktion prüft selbst, ob ihre Section auf der Seite ist.
(function () {
  if (window.__kkEditorial) return;
  window.__kkEditorial = true;

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const scrollers = [];
  // Horizon scrollt auf dem Desktop (ab 990 px) die .page-wrapper statt des Fensters, auf dem Handy das Dokument.
  const pageScroller = () => (matchMedia("(min-width: 990px)").matches && $(".page-wrapper")) || document.scrollingElement || document.documentElement;
  const scrollTop = () => Math.max(window.scrollY || 0, $(".page-wrapper")?.scrollTop || 0);
  // Schwebende Elemente (Nach-oben-Button, Fortschrittsbalken) hängen direkt am body, damit „fixed“ sicher am Bildschirm klebt.
  let floatHost = null;
  const floating = () => {
    if (!floatHost) { floatHost = document.createElement("div"); floatHost.className = "kk kk-float"; document.body.appendChild(floatHost); }
    return floatHost;
  };

  /* ---------- Videoquelle: Safari (iPhone) bekommt Shopifys HLS-Stream, startet adaptiv und schneller ---------- */
  const HLS = !!document.createElement("video").canPlayType("application/vnd.apple.mpegurl");
  const vsrc = (u) => {
    const m = HLS && u && u.match(/^(https:\/\/cdn\.shopify\.com\/videos\/c\/vp\/([0-9a-f]+)\/)\2\.[^/]*\.mp4$/);
    return m ? `${m[1]}${m[2]}.m3u8` : u;
  };

  /* ---------- Würfelaugen ---------- */
  const PIPS = {
    1: [[50, 50]], 2: [[28, 28], [72, 72]], 3: [[26, 26], [50, 50], [74, 74]],
    4: [[28, 28], [72, 28], [28, 72], [72, 72]], 5: [[26, 26], [74, 26], [50, 50], [26, 74], [74, 74]],
    6: [[28, 24], [72, 24], [28, 50], [72, 50], [28, 76], [72, 76]],
  };
  const paintFace = (el, n, dot = "#09110D") => {
    el.style.backgroundImage = PIPS[n].map(() => `radial-gradient(circle,${dot} 0 46%,transparent 52%)`).join(",");
    el.style.backgroundSize = PIPS[n].map(() => "17% 17%").join(",");
    el.style.backgroundPosition = PIPS[n].map(([x, y]) => `${((x - 8.5) / 83) * 100}% ${((y - 8.5) / 83) * 100}%`).join(",");
  };

  /* ---------- Würfeltabelle laut Regelwerk + Videostellen (Sekunden) ---------- */
  const EVENTS = {
    2: ["Rote Karte", "Du würfelst sofort noch einmal und schießt. Die aktuelle Runde wird normal zu Ende gespielt, auch dein Mitspieler ist noch dran. Erst in der nächsten Runde setzt dein ganzes Team aus.", "wuerfel-2-rote-karte", 0, 0],
    3: ["Ecke", "Genau zwei Schüsse: Flanke von der gegnerischen Eckfahne, dann Kopfball von dort, wo die Flanke liegt.", "wuerfel-3-ecke", 0, 0],
    4: ["Freistoß", "Schuss von der Freistoßlinie, ohne Mauer.", "wuerfel-4-freistoss", 0, 0],
    5: ["Fünferlinie", "Korken auf die eigene 5-Meter-Linie legen und Richtung gegnerisches Tor kicken.", "wuerfel-5-fuenferlinie", 0, 0],
    6: ["Sechzehner", "Schuss von der eigenen Strafraumgrenze Richtung gegnerisches Tor.", "wuerfel-6-sechzehner", 0, 0],
    7: ["Eigene Ecke", "Schuss von der eigenen Eckfahne über das ganze Feld.", "wuerfel-7-eigene-ecke", 0, 0],
    8: ["Einwurf", "Der Korken wird von der Seitenlinie ins Feld gekickt.", "wuerfel-8-einwurf", 0, 0],
    9: ["Freistoß mit Mauer", "Jeder Gegenspieler kickt erst einen Mauer-Korken von seiner Eckfahne auf deinen. Trifft er: sofort Elfmeter. Sonst schießt du deinen Freistoß.", "mauer-9b-elfmeter", 0, 0],
    10: ["Abseits", "Nur du setzt in der aktuellen Runde aus.", "wuerfel-10-abseits", 0, 0],
    11: ["Mittelpunkt", "Schuss vom Anstoßpunkt.", "mittelpunkt-11", 0, 0],
    12: ["Elfmeter", "Direkter Schuss vom Elfmeterpunkt.", "elfmeter-12", 0, 0],
  };

  /* ---------- Startpunkte auf der Mini-Matte (Koordinaten der 120-cm-Grafik, 2000 × 714) ---------- */
  const GOAL = [1945, 355];
  const START = {
    2: { card: true, text: "Rote Karte: noch einmal würfeln, dein Team setzt erst die nächste Runde aus" },
    3: { at: [1915, 28], via: [1700, 290], text: "Gegnerische Eckfahne: Flanke, dann Kopfball von dort, wo sie liegt" },
    4: { at: [1370, 232], text: "Freistoß-Markierung in der gegnerischen Hälfte" },
    5: { at: [182, 300], text: "Eigene Fünferlinie, Schuss übers ganze Feld" },
    6: { at: [337, 470], text: "Eigene Strafraumgrenze, Schuss übers ganze Feld" },
    7: { at: [86, 690], text: "Eigene Eckfahne, Schuss übers ganze Feld" },
    8: { at: [1100, 680], text: "Einwurf-Markierung an der Seitenlinie" },
    9: { at: [1370, 232], wall: true, text: "Freistoß-Markierung, die Mauer kommt von den gegnerischen Eckfahnen" },
    10: { flag: true, text: "Abseits: nur du setzt in dieser Runde aus" },
    11: { at: [999, 355], text: "Anstoßpunkt in der Mitte" },
    12: { at: [1735, 355], text: "Elfmeterpunkt, Schuss aufs gegnerische Tor" },
  };

  /* ---------- Navigation ---------- */
  function initNav() {
    const nav = $("#nav");
    if (!nav) return;
    const burger = $(".nav__burger", nav), mnav = $("#mnav");
    const setOpen = (open) => {
      burger.setAttribute("aria-expanded", open);
      burger.setAttribute("aria-label", open ? "Menü schließen" : "Menü öffnen");
      mnav.hidden = !open;
    };
    burger.addEventListener("click", () => setOpen(burger.getAttribute("aria-expanded") !== "true"));
    mnav.addEventListener("click", (e) => { if (e.target.closest("a")) setOpen(false); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !mnav.hidden) { setOpen(false); burger.focus(); } });
    // Reiter „Service“: schließt bei Klick daneben, auf einen Link oder mit Escape
    const more = $(".nav__more", nav);
    if (more) {
      document.addEventListener("click", (e) => { if (more.open && !more.contains(e.target)) more.open = false; });
      more.addEventListener("click", (e) => { if (e.target.closest("a")) more.open = false; });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape" && more.open) { more.open = false; $("summary", more).focus(); } });
    }
    let lastY = scrollTop();
    scrollers.push(() => {
      const y = scrollTop();
      nav.classList.toggle("is-hidden", y > lastY + 2 && y > 500 && mnav.hidden && !(more && more.open));
      if (y < lastY - 2) nav.classList.remove("is-hidden");
      lastY = y;
    });
  }

  /* ---------- Hero: Matte ausrollen, Korken ins Tor ---------- */
  function initHero() {
    const hero = $(".hero");
    if (!hero) return;
    const start = () => requestAnimationFrame(() => hero.classList.add("is-play"));
    const img = $(".unroll__mat img", hero);
    if (img.complete) start(); else { img.addEventListener("load", start, { once: true }); setTimeout(start, 1500); }
    $("#unrollAgain").addEventListener("click", () => {
      hero.classList.remove("is-play");
      void hero.offsetWidth;
      hero.classList.add("is-play");
    });
  }

  /* ---------- So läuft ein Zug: vier Schritte, Klick wählt den Schritt (keine Scroll-Steuerung) ---------- */
  function initStory() {
    const story = $("#spiel");
    if (!story) return;
    const mat = $("#storyMat"), steps = $$("#steps li"), score = $("#score");
    $$(".story__dice .die", story).forEach((d) => paintFace(d, 6));
    const show = (idx) => {
      mat.dataset.step = idx;
      steps.forEach((s, i) => {
        s.classList.toggle("is-on", i === idx);
        const btn = $("button", s);
        if (btn) btn.setAttribute("aria-pressed", i === idx ? "true" : "false");
      });
      score.textContent = idx === 3 ? "1 : 0" : "0 : 0";
    };
    steps.forEach((s, i) => s.addEventListener("click", () => show(i)));
  }


  /* ---------- Handy-Leiste „Zum Launch“: sichtbar nach dem Hero, weg am Anmeldeformular ---------- */
  function initDock() {
    const d = $("#kkDock"), h = $("#top"), a = $("#anpfiff");
    if (!d || !h || !("IntersectionObserver" in window)) return;
    let heroOut = false, endIn = false;
    const u = () => {
      const on = heroOut && !endIn;
      d.classList.toggle("is-on", on);
      $("#kkTotop")?.classList.toggle("is-lifted", on);
    };
    new IntersectionObserver((e) => { heroOut = !e[0].isIntersecting; u(); }).observe(h);
    if (a) new IntersectionObserver((e) => { endIn = e[0].isIntersecting; u(); }).observe(a);
  }

  /* ---------- Nach oben: erscheint nach einer Bildschirmhöhe, springt sanft an den Seitenanfang ---------- */
  function initTotop() {
    const b = $("#kkTotop");
    if (!b) return;
    floating().appendChild(b);
    scrollers.push(() => b.classList.toggle("is-on", scrollTop() > window.innerHeight * 0.9));
    b.addEventListener("click", () => {
      const behavior = reduce ? "auto" : "smooth";
      pageScroller().scrollTo({ top: 0, behavior });
      if (window.scrollY > 0) window.scrollTo({ top: 0, behavior });
    });
  }

  /* ---------- Mini-Matte ---------- */
  function updateMini(n) {
    const box = $("#mini");
    if (!box) return;
    const d = START[n], cap = $("#miniCap"), path = $("#miniPath");
    $("#miniCard").classList.toggle("is-on", !!d.card);
    $("#miniFlag").classList.toggle("is-on", !!d.flag);
    $("#miniText").textContent = d.text;
    const show = !!d.at;
    cap.style.opacity = path.style.opacity = show ? 1 : 0;
    if (show) {
      cap.style.transform = `translate(${d.at[0]}px,${d.at[1]}px)`;
      path.setAttribute("d", d.via
        ? `M${d.at[0]} ${d.at[1]} Q${d.via[0] + 120} ${d.at[1] + 40} ${d.via[0]} ${d.via[1]} L${GOAL[0]} ${GOAL[1]}`
        : `M${d.at[0]} ${d.at[1]} L${GOAL[0]} ${GOAL[1]}`);
    }
    const wall = (g, from, to) => { const p = d.wall ? to : from; g.style.transform = `translate(${p[0]}px,${p[1]}px)`; g.style.opacity = d.wall ? 1 : 0; };
    wall($("#miniWall1"), [1915, 28], [1478, 268]);
    wall($("#miniWall2"), [1915, 686], [1500, 330]);
  }

  /* ---------- Würfel + Video ---------- */
  function initDice() {
    const sec = $("#wuerfel");
    if (!sec) return;
    const SRC = {};
    $$(".dice__sources [data-clip]", sec).forEach((s) => { SRC[s.dataset.clip] = { src: s.dataset.src, poster: s.dataset.poster }; });

    const cubes = [$("#cubeA"), $("#cubeB")];
    cubes.forEach((c) => { for (let n = 1; n <= 6; n++) paintFace($(".f" + n, c), n); });

    const chips = $(".chips", sec);
    chips.innerHTML = Object.entries(EVENTS).map(([n, [t]]) =>
      `<button type="button" class="chip${n == 2 ? " chip--red" : ""}" data-n="${n}" aria-pressed="${n == 12}"><b>${n}</b><span>${t}</span></button>`).join("");

    const result = $(".result", sec), resNum = $("#resNum"), resTitle = $("#resTitle"), resText = $("#resText");
    const phone = $(".phone", sec), video = $("#diceVideo"), playBtn = $("#dicePlay"), soundBtn = $("#diceSound");
    const variants = $("#variants");
    let seg9 = "mauer-9b-elfmeter", current = { clip: "elfmeter-12", from: 0, to: 0 }, sound = false;

    function play() {
      video.muted = !sound;
      const pr = video.play();
      if (pr) pr.catch(() => { video.muted = true; video.play().catch(() => {}); });
      phone.classList.add("is-playing");
    }
    function loadClip(clip, from, to, autoplay) {
      const s = SRC[clip];
      current = { clip, from, to };
      if (!s) return;
      if (!autoplay && !video.getAttribute("src")) { video.poster = s.poster || ""; return; }
      if (video.dataset.clip !== clip) {
        video.dataset.clip = clip;
        video.poster = s.poster || "";
        video.preload = "auto";
        video.src = vsrc(s.src);
      }
      const seek = () => { try { video.currentTime = from; } catch (e) {} };
      if (video.readyState >= 1) seek(); else video.addEventListener("loadedmetadata", seek, { once: true });
      // iPhone lädt erst nach play(): deshalb sofort starten, nicht auf loadedmetadata warten
      if (autoplay) play(); else { video.pause(); phone.classList.remove("is-playing"); }
    }
    video.addEventListener("timeupdate", () => {
      const end = current.to || video.duration;
      if (end && video.currentTime >= end - 0.05) video.currentTime = current.from;
    });

    function showEvent(n, autoplay) {
      const [t, txt, clip, from, to] = EVENTS[n];
      resNum.textContent = n; resTitle.textContent = t; resText.textContent = txt;
      result.classList.toggle("is-red", n == 2);
      result.classList.remove("is-new"); void result.offsetWidth; result.classList.add("is-new");
      $$(".chip", chips).forEach((c) => c.setAttribute("aria-pressed", c.dataset.n == n));
      variants.hidden = n != 9;
      updateMini(n);
      loadClip(n == 9 ? seg9 : clip, from, to, autoplay);
    }
    chips.addEventListener("click", (e) => { const c = e.target.closest(".chip"); if (c) showEvent(+c.dataset.n, true); });
    variants.addEventListener("click", (e) => {
      const b = e.target.closest("button"); if (!b) return;
      seg9 = b.dataset.clip;
      $$("button", variants).forEach((x) => x.setAttribute("aria-pressed", x === b));
      loadClip(seg9, 0, 0, true);
    });
    playBtn.addEventListener("click", () => {
      if (video.paused) { if (!video.getAttribute("src")) loadClip(current.clip, current.from, current.to, true); else play(); }
      else { video.pause(); phone.classList.remove("is-playing"); }
    });
    soundBtn.addEventListener("click", () => {
      sound = !sound;
      soundBtn.setAttribute("aria-pressed", sound);
      soundBtn.textContent = sound ? "Ton aus" : "Ton an";
      video.muted = !sound;
    });

    const FACE = { 1: [0, 0], 6: [0, 180], 2: [0, -90], 5: [0, 90], 3: [-90, 0], 4: [90, 0] };
    const spins = [0, 0];
    const setCube = (i, n, spin) => {
      const [rx, ry] = FACE[n];
      spins[i] += spin ? 2 : 0;
      cubes[i].style.transform = `rotateX(${rx + spins[i] * 360 - 14}deg) rotateY(${ry + spins[i] * 360 + 16}deg)`;
    };
    setCube(0, 6); setCube(1, 6);
    $("#rollBtn").addEventListener("click", () => {
      const a = 1 + Math.floor(Math.random() * 6), b = 1 + Math.floor(Math.random() * 6);
      setCube(0, a, true); setCube(1, b, true);
      setTimeout(() => showEvent(a + b, true), reduce ? 0 : 900);
    });
    showEvent(12, false);
  }

  /* ---------- Video-Leiste ---------- */
  function initReel() {
    const reel = $("#reel");
    if (!reel) return;
    $$(".clip", reel).forEach((clip) => {
      const v = $("video", clip);
      $(".clip__play", clip).addEventListener("click", () => {
        if (!v.getAttribute("src") && v.dataset.src) v.src = vsrc(v.dataset.src);
        if (v.paused) {
          $$(".clip video").forEach((o) => { if (o !== v) { o.pause(); o.closest(".clip").classList.remove("is-playing"); } });
          v.muted = false; v.play().catch(() => { v.muted = true; v.play().catch(() => {}); }); clip.classList.add("is-playing");
        } else { v.pause(); clip.classList.remove("is-playing"); }
      });
    });
    $$("[data-reel]").forEach((b) => b.addEventListener("click", () => {
      const w = $(".clip", reel).offsetWidth + 16;
      reel.scrollBy({ left: +b.dataset.reel * w * 2, behavior: reduce ? "auto" : "smooth" });
    }));
  }

  /* ---------- Video-Fenster ---------- */
  let modal;
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-play]");
    if (!b || !b.dataset.src) return;
    if (!modal) {
      modal = document.createElement("dialog");
      modal.className = "kk-modal";
      modal.innerHTML = '<video playsinline controls></video><button class="kk-modal__close" type="button" aria-label="Video schließen">×</button>';
      document.body.appendChild(modal);
      const v = $("video", modal);
      $(".kk-modal__close", modal).addEventListener("click", () => modal.close());
      modal.addEventListener("click", (ev) => { if (ev.target === modal) modal.close(); });
      modal.addEventListener("close", () => v.pause());
    }
    const v = $("video", modal);
    v.poster = b.dataset.poster || ""; v.src = vsrc(b.dataset.src); v.setAttribute("aria-label", b.dataset.title || "Video");
    modal.showModal();
    v.muted = false;
    v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
  });

  /* ---------- Anmeldung (nur Vorschau) ---------- */
  function initSignup() {
    const form = $("#signup");
    if (!form || !form.hasAttribute("data-preview")) return;
    const msg = $("#signupMsg");
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const v = form.email.value.trim();
      if (!/^\S+@\S+\.\S+$/.test(v)) { msg.textContent = "Bitte gib eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de."; form.email.focus(); return; }
      msg.textContent = "Eingetragen. Wir melden uns zum Anpfiff.";
      form.reset();
    });
  }

  /* ---------- Spielregeln: aktiven Abschnitt markieren ---------- */
  function initToc() {
    const toc = $(".rules__toc");
    if (!toc) return;
    const links = $$("a", toc);
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) links.forEach((a) => a.classList.toggle("is-on", a.getAttribute("href") === "#" + e.target.id));
    }), { rootMargin: "-40% 0px -55% 0px" });
    links.forEach((a) => { const t = $(a.getAttribute("href")); if (t) io.observe(t); });
  }

  /* ---------- Cookie-Einstellungen (Shopify-Cookie-Banner) ---------- */
  function initCookies() {
    $$("[data-cookie-settings]").forEach((b) => {
      const api = () => window.privacyBanner && window.privacyBanner.showPreferences;
      b.hidden = !window.Shopify;
      b.addEventListener("click", () => { if (api()) window.privacyBanner.showPreferences(); else location.href = "/policies/privacy-policy"; });
    });
  }

  /* ---------- Linienregel-Animationen: abspielen, sobald sichtbar ---------- */
  function initLineFigs() {
    const figs = $$(".linefig");
    if (!figs.length) return;
    const play = (f) => {
      f.classList.remove("is-play", "is-done"); void f.offsetWidth; f.classList.add("is-play");
      clearTimeout(f._t); f._t = setTimeout(() => f.classList.add("is-done"), reduce ? 0 : 2600);
    };
    figs.forEach((f) => { const b = $(".lf-again", f); if (b) b.addEventListener("click", () => play(f)); });
    if (!("IntersectionObserver" in window)) { figs.forEach(play); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); play(e.target); } }), { threshold: 0.5 });
    figs.forEach((f) => io.observe(f));
  }

  /* ---------- Vier Modi: Trikot wählt die Erklärung darunter ---------- */
  function initModi() {
    const tabs = $$(".trikot[aria-controls]");
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-selected", on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) panel.classList.toggle("is-on", on);
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener("click", () => {
        select(t);
        const panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel && panel.getBoundingClientRect().top > innerHeight * 0.8) panel.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      });
      t.addEventListener("keydown", (e) => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  }

  /* ---------- Scroll: Fortschrittsleiste ---------- */
  function initProgress() {
    if (document.documentElement.scrollHeight < innerHeight * 2.5) return;
    const bar = document.createElement("div");
    bar.className = "kk-progress";
    bar.setAttribute("aria-hidden", "true");
    floating().appendChild(bar);
    scrollers.push(() => {
      const s = pageScroller();
      const max = s.scrollHeight - s.clientHeight;
      bar.style.transform = `scaleX(${clamp(max > 0 ? scrollTop() / max : 0)})`;
    });
  }

  /* ---------- Scroll: Überschriften, Texte, Karten und Fotos einblenden (einmalig) ---------- */
  function initReveal() {
    if (!("IntersectionObserver" in window)) return;
    const skip = ".hero, #assembly, .story, .nav, .mnav, .kk-modal, .guide__steps";
    const pick = (sel, cls) => $$(sel).filter((el) => !el.closest(skip)).map((el) => (el.classList.add(cls), el));
    const els = [
      ...pick(".sec .h1, .sec .h2, .sec > .lead, .sec .lead, .guide__head > *, .guide__card, .pcard, .trikot, .faq__list details, .rsec > h2", "rv"),
      ...pick(".tor__photos figure, .guide__videos .vidlink", "rv-clip"),
    ];
    const io = new IntersectionObserver((entries) => {
      entries.filter((e) => e.isIntersecting).forEach((e, i) => {
        e.target.style.setProperty("--rv-d", `${Math.min(i, 4) * 70}ms`);
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Aufbau-Anleitung: Schritte steuern das Bild beim Scrollen ---------- */
  function initGuide() {
    const steps = $$(".gstep");
    const list = $(".guide__list");
    const bar = $(".guide__bar");
    if (!steps.length || !list) return;
    const imgs = $$(".guide__stage img");
    const now = $("#guideNow");
    const show = (i) => {
      steps.forEach((s, k) => s.classList.toggle("is-on", k === i));
      imgs.forEach((im, k) => im.classList.toggle("is-on", k === i));
      if (now) now.textContent = i + 1;
    };
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) show(steps.indexOf(e.target)); }),
        { rootMargin: "-45% 0px -45% 0px" });
      steps.forEach((s) => io.observe(s));
    }
    scrollers.push(() => {
      const r = list.getBoundingClientRect();
      if (bar) bar.style.transform = `scaleY(${clamp((innerHeight * 0.5 - r.top) / r.height).toFixed(3)})`;
    });
  }

  /* Falls das 3D-Skript gar nicht startet (z. B. Netzfehler), bleibt der Ladehinweis nicht ewig stehen */
  setTimeout(() => {
    const l = $("#torLoad");
    if (!l || l.classList.contains("is-done") || l.classList.contains("is-error")) return;
    l.classList.add("is-error");
    $("#torLoadTitle").textContent = "Das 3D-Tor braucht etwas länger";
    $("#torLoadSub").textContent = "Die Verbindung ist gerade langsam. Warte kurz oder lade die Seite neu.";
    const b = $("#torReload"); b.hidden = false; b.onclick = () => location.reload();
  }, 25000);
  initLineFigs(); initTotop(); initCookies(); initToc(); initNav(); initHero(); initStory(); initDock(); initDice(); initReel(); initSignup(); initModi(); initGuide(); initReveal(); initProgress();
  let ticking = false;
  const run = () => { ticking = false; scrollers.forEach((f) => f()); };
  // capture: true fängt auch das Scrollen der .page-wrapper ab (Scroll-Ereignisse von Elementen steigen nicht bis zum Fenster auf)
  document.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true, capture: true });
  addEventListener("resize", run);
  run();
})();
